import { all } from "redux-saga/effects";

export function* watchTraining() {
  yield all([]);
}
